// extracted by mini-css-extract-plugin
export default {"container":"ModalFooter_container__o+vsd","overlay":"ModalFooter_overlay__BAOqY"};